/**
 * Auth Token Utility
 * Manages JWT access token storage and retrieval
 */

export const STORAGE_KEY_TOKEN = 'charti_access_token';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_TOKEN);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(STORAGE_KEY_TOKEN, token);
};

export const clearAccessToken = (): void => {
  localStorage.removeItem(STORAGE_KEY_TOKEN);
};
